import request from "axios";
/** 分页获取公司管理 */
export const getEnterpriseDistributionList = (params) => {
  return request({
    url: "/lebo-member/web/partner/company-manage/list",
    method: "get",
    params
  });
};
/** 新增公司接口 */
export const addEnterpriseDistribution = (data) => {
  return request({
    url: "/lebo-member/web/partner/company-manage/save",
    method: "post",
    data
  });
}
/** 编辑公司接口 */
export const updateEnterpriseDistribution = (data) => {
  return request({
    url: "/lebo-member/web/partner/company-manage/update",
    method: "post",
    data
  });
}
